import { floor } from '../common'

export default class Donut {
  constructor({
    element,
    colors = [],
    decimals = 4,
    radius = 35,
    cx = 50,
    cy = 50,
  }) {
    if (!(element instanceof HTMLElement))
      throw new Error('element is not a HTMLElement')
    this.element = element
    this.colors = colors
    this.decimals = decimals
    this.radius = radius
    this.cx = cx
    this.cy = cy

    this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    this.svg.setAttribute('viewBox', '0 0 100 100')
    this.svg.style.aspectRatio = '1'
    this.element.appendChild(this.svg)
  }

  setData(data) {
    this.data = data
    this.svg.innerHTML = this.calc()
  }

  arcradius(degrees) {
    const radians = ((degrees - 90) * Math.PI) / 180.0
    return {
      x: this.cx + this.radius * Math.cos(radians),
      y: this.cy + this.radius * Math.sin(radians),
    }
  }

  calc() {
    const arr = []
    let total = 0
    let beg = 0
    let end = 0

    for (let i = 0; i < this.data.length; i++) total += this.data[i]

    for (let i = 0; i < this.data.length; i++) {
      const item = this.data[i]

      const p = floor(((item + 1) / total) * 100, 2)

      end = beg + (360 / 100) * p

      const b = this.arcradius(end)
      const e = this.arcradius(beg)
      const la = end - beg <= 180 ? 0 : 1

      const d = [
        'M',
        floor(b.x, this.decimals),
        floor(b.y, this.decimals),
        'A',
        this.radius,
        this.radius,
        0,
        la,
        0,
        floor(e.x, this.decimals),
        floor(e.y, this.decimals),
      ].join(' ')

      arr.push(
        `<path d="${d}" stroke="${
          this.colors[i] || 'none'
        }" fill="none" stroke-width="25" />`
      )
      beg = end
    }

    return arr.join('')
  }
}
